<template>
    <div>
        <div class="vx-col w-full mb-base">
            <vs-card class="p-4 mb-6">
                <div slot="header" class="flex flex-wrap items-center justify-between">
                    <div class="flex items-center">
                        <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                        <h4 class="ml-5">Cancel Good Receive</h4>
                    </div>
                    <div class="flex items-center" >
                        <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="save">Save</vs-button>
                    </div>
                </div>
                <div class="vx-row mt-6">
                    <div class="vx-col md:w-1/4 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                                <vs-input class="w-full" label="GR ID" v-model="$route.params.data.id" disabled/>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                                <vs-input class="w-full" label="GR Reference"  :disabled="true" v-model="$route.params.data.reference"/>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col md:w-1/4 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-full">
                                <vs-input class="w-full" label="GR Status" disabled v-model="$route.params.data.status"/>
                            </div>
                        </div>
                    </div>
                </div>
                <vs-table stripe :data="$route.params.data.list_cancel" class="mt-base" hoverFlat search pagination max-items="20" multiple v-model="selected">
                    <template slot="thead">
                        <vs-th>Line ID</vs-th>
                        <vs-th>Product Code</vs-th>
                        <vs-th>Description</vs-th>
                        <vs-th>Pack ID</vs-th>
                        <vs-th>Batch</vs-th>
                        <vs-th>Exp. Date</vs-th>
                        <vs-th>Stock Type</vs-th>
                        <vs-th>Base Qty</vs-th>
                        <vs-th>Base UoM</vs-th>
                    </template>
                    <template slot-scope="{data}">
                        <vs-tr :data="tr" v-for="(tr, indextr) in data" :key="indextr">
                            <vs-td>
                                {{ indextr + 1 }}
                            </vs-td>
                            <vs-td>
                                {{ tr.product_code }}
                            </vs-td>
                            <vs-td>
                                {{ tr.description }}
                            </vs-td>
                            <vs-td>
                                {{ tr.pack_id }}
                            </vs-td>
                            <vs-td>
                                {{ tr.batch }}
                            </vs-td>
                            <vs-td>
                                {{ tr.expired_date }}
                            </vs-td>
                            <vs-td>
                                {{ tr.stock_type }}
                            </vs-td>
                            <vs-td>
                                <vs-input class="w-full" v-model="tr.base_qty"/>
                            </vs-td>
                            <vs-td>
                                {{ tr.base_uom }}
                            </vs-td>
                        </vs-tr>
                    </template>
                </vs-table>
            </vs-card>
        </div>
    </div>
</template>

<script type="text/javascript">
	import '@/assets/scss/vuesax/_wmsTheme.scss';

	export default {
		data(){
			return {
                isLoading: true,
                selected: []
			}
		},
	watch:{
	    isLoading: function(){
	        if(this.isLoading){
	            this.$vs.loading()
	        }
	        else{
	            this.$vs.loading.close()
	        }
	    },
	},
	methods:{
        back() {
            this.$router.push({
                name: 'good-receive-view',
                params: {
                    id: this.$route.params.id
                }
            })
        },
        save() {
            if(!this.selected.length) {
                return this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: 'No line selected.'
                })
            }

            this.isLoading = true

            const data = {
                id: this.$route.params.data.id,
                cancel: this.selected.map(i => {
                    return {
                        id: i.id,
                        base_qty: i.base_qty
                    }
                })
            }

            this.$http.post('inbound/goodreceive/cancel', data)
            .then(res => {
                this.isLoading = false
                this.$vs.notify({
                    color: 'success',
                    title: 'Success',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: res.data.message || 'Canceled successfully.'
                })
                this.back()
            })
            .catch(error => this.handleError(error))
        }
	},
    mounted(){
        if(this.$route.params.data) {
            console.log(this.$route.params.data.id);
            
            this.selected = this.$route.params.data.list_cancel
            setTimeout(() => {
                this.isLoading = false
            }, 500)
        }
        else {
            this.back()
        }
    },
}
</script>